module.exports = __webpack_public_path__ + "img/1760.9468787a.gif";